import Vue from 'vue'
import routes from '@/router/router'
import Router from 'vue-router'

Vue.use(Router)
const router = new Router({
    routes
})
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    if (to.name == 'login') {
        next();
    } else {
        //判断前往的一级菜单是否拥有权限
        let authorities = Vue.prototype.getLocalStorage('authorities').split(',');
        switch (to.name) {
            //首页
            case "home":
                if (authorities.includes('summary')) {
                    next();
                } else {
                    Vue.prototype.$Message.error('未获得该页面权限');
                }
                break;
            //媒体监测
            case "mediaSpec":
                if (authorities.includes('media')) {
                    next();
                } else {
                    Vue.prototype.$Message.error('未获得该页面权限');
                }
                break;
            //群组监测
            case "groupSpec":
                if (authorities.includes('group')) {
                    next();
                } else {
                    Vue.prototype.$Message.error('未获得该页面权限');
                }
                break;
            //预警列表
            case "warningList":
                if (authorities.includes('warn_list')) {
                    next();
                } else {
                    Vue.prototype.$Message.error('未获得该页面权限');
                }
                break;
            //分析报告
            case "report":
                if (authorities.includes('report')) {
                    next();
                } else {
                    Vue.prototype.$Message.error('未获得该页面权限');
                }
                break;
            case "specConfig":
                if (authorities.includes('job_config')) {
                    next();
                } else {
                    Vue.prototype.$Message.error('未获得该页面权限');
                }
                break;
            case "focus":
                if (authorities.includes('focus')) {
                    next();
                }   else {
                    Vue.prototype.$Message.error('未获得该页面权限');
                }
                break;
            case "event":
                if (authorities.includes('event')) {
                    next();
                } else {
                    Vue.prototype.$Message.error('未获得该页面权限');
                }
                break;
            default:
                next();
                break;
        }
    }
})

export default router